<div
  tabindex="-1"
  class="conversation-ids"
  (cvClickOutside)="hideTooltip()"
  (keydown)="showTooltip()"
  (click)="showTooltip()"
>
  <span
    [pTooltip]="tooltipContent"
    [autoHide]="false"
    [hideDelay]="2000"
    tooltipStyleClass="conversation-ids__tooltip"
    class="pi pi-info-circle"
  ></span>
  <span>ID: {{ currentId?.value }}</span>
</div>

<ng-template #tooltipContent>
  <div class="conversation-ids__header">Communication IDs</div>
  <ng-container *ngTemplateOutlet="conversationID; context: { id: ids?.callDetailId, title: 'CDR ID' }"></ng-container>
  <ng-container
    *ngTemplateOutlet="conversationID; context: { id: ids?.aceCommunicationId, title: 'Comm ID' }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="conversationID; context: { id: ids?.aceSessionId, title: 'Session ID' }"
  ></ng-container>
  <ng-container *ngTemplateOutlet="conversationID; context: { id: ids?.routingId, title: 'Routing ID' }"></ng-container>
</ng-template>

<ng-template #conversationID let-id="id" let-title="title">
  @if (id) {
    <div class="conversation-ids__item">
      <div class="conversation-ids__id">{{ title }}: {{ id }}</div>
      <span tabindex="1" class="pi pi-copy" (keydown)="onCopy(id)" (click)="onCopy(id)"></span>
    </div>
  }
</ng-template>
